/*
 * @Author: 01399133
 * @Date: 2021-06-07 16:26:50
 * @LastEditors: 01399133
 * @LastEditTime: 2021-06-24 11:58:33
 * @Description: file content
 */
import "./public-path";
import Vue from "vue";
import App from "./App";
import router from "./router";
import routerBeforeEach from "./router/routerBeforeEach";
import routerAfterEach from "./router/routerAfterEach";
import store from "./store";
import QianKunUtils from "@/utils/QianKunUtils";
import * as storeFilters from "@/plugins/vue-filter";
import CookieUtils from "@/libs/esg-acsp-core-vue-lib/utils/CookieUtils";

if (process.env.NODE_ENV === "development") {
  require("./mock/index.js");
}

//加载插件，插件统一写在/plugins目录下面
const pluginsFiles = require.context("./plugins", false, /\.js$/);
pluginsFiles.keys().forEach((key) => {
  pluginsFiles(key).default &&
    pluginsFiles(key).default({ app: App, router, store });
});

router.beforeEach((to, from, next) => {
  routerBeforeEach({ to, from, next, app: App, router, store });
});
router.afterEach((to, from) => {
  window.scrollTo(0, 0);
  routerAfterEach({ to, from, app: App, router, store });
});

/**
 * 超出省略号，鼠标移上去展示全部指令
 */
Vue.directive("beyond", {
  inserted(el) {
    el.addEventListener("mouseover", () => {
      if (el.scrollWidth > el.clientWidth) {
        el.classList.add("beyond-over");
      }
    });
    el.addEventListener("mouseout", () => {
      el.classList.remove("beyond-over");
    });
  },
});

/**
 * @description: 防重发指令
 * @description: 示例 <a-button v-debounce></a-button>
 * @param {*}
 * @return {*}
 */
Vue.directive("debounce", {
  inserted(el, binding) {
    el.addEventListener("click", () => {
      if (!el.disabled) {
        el.disabled = true;
        setTimeout(() => {
          el.disabled = false;
        }, binding.value || 1500);
      }
    });
  },
});
// 注册全局filters
Object.keys(storeFilters).forEach((key) => {
  Vue.filter(key, storeFilters[key]);
});

// 微前端相关配置
let instance = null;
function render(props = {}) {
  const { container } = props;
  instance = new Vue({
    router,
    store,
    render: (h) => h(App),
  }).$mount(container ? container.querySelector("#app") : "#app");
}

// 独立运行时
if (!window.__POWERED_BY_QIANKUN__) {
  render();
}

export async function bootstrap() {
  console.log("[vue] vue app bootstraped");
}
export async function mount(props) {
  console.log("[vue] props from main framework", props);
  QianKunUtils.setCommonData(props);
  render(props);
}
export async function unmount() {
  instance.$destroy();
  instance.$el.innerHTML = "";
  instance = null;
}

const isBetaEnv =
  (process.env.VUE_APP_ENV || "").indexOf("gray") > -1 ||
  +CookieUtils.getCookie("grayScale") === 1;
const cssColor = isBetaEnv ? "#666" : "#DC1D32";
window.console.log(
  `%c      ____  ______    _______________  ____  ______
     / __ \\/ ____/   / ___/_  __/ __ \\/ __ \\/ ____/
    / /_/ / /  ______\\__ \\ / / / / / / /_/ / __/   
   / ____/ /__/_____/__/ // / / /_/ / _, _/ /___   
  /_/    \\____/    /____//_/  \\____/_/ |_/_____/   
  `,
  `color:${cssColor};`
);
window.console.log(
  `%c 数字商店平台 - PC - ${isBetaEnv ? "beta" : "production"} %c 🇻🇳🇻🇺 ${
    process.env.PKG_BRANCH
  }  %c ⏰  ${new Date(process.env.BUILD_TIME).toLocaleString()}`,
  `background:${cssColor}; padding:2px 3px; border:1px solid ${cssColor}; border-radius:3px 0 0 3px; color:#fff;`,
  `background:#35495E; padding:2px 3px; border:1px solid ${cssColor}; border-radius:3px 0 0 3px; color:#fff;`,
  `background:#fff; padding:2px 3px; border:1px solid ${cssColor}; border-radius:0 3px 3px 0; color:${cssColor};`
);
